import { cva } from 'class-variance-authority';

/**
 * Base UserStats section styles
 */
export const baseUserStatsStyles = [
  'flex',
  'flex-col',
  'gap-5',
  'w-full',
].join(' ');

export const userStatsVariants = cva(baseUserStatsStyles, {
  variants: {},
  defaultVariants: {},
});